import { render, staticRenderFns } from "./Bancos.view.vue?vue&type=template&id=0467c5ac"
import script from "./Bancos.view.vue?vue&type=script&lang=js"
export * from "./Bancos.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports